import React from 'react';
import Grid from '@mui/material/Grid2';
import { LenderFieldMap, PortalConfiguration } from '@trnsact/trnsact-shared-types';
import { MappingInput } from '../inputs/MappingInput';
import { MappingStatusIcon } from './MappingStatusIcon';
import { TrnsactInput } from './TrnsactInput';

interface Props {
  field: LenderFieldMap;
  portalConfiguration: PortalConfiguration;
  onValueChange: (lenderProperty: string, newValue: any) => void;
}

export const MappingRow = ({ field, portalConfiguration, onValueChange }: Props) => {
  return (
    <Grid container spacing={2}>
      <Grid size={5}>
        <TrnsactInput field={field} portalConfiguration={portalConfiguration} />
      </Grid>
      <Grid size={2} display="flex" justifyContent="center" alignItems="center">
        <MappingStatusIcon field={field} />
      </Grid>
      <Grid size={5} display="flex" alignItems="center">
        <MappingInput field={field} onValueChange={onValueChange} />
      </Grid>
    </Grid>
  );
};
